var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 9C19 8.46957 18.7893 7.96086 18.4142 7.58579C18.0391 7.21071 17.5304 7 17 7H15.6667V3H6.33333V7H5C4.46957 7 3.96086 7.21071 3.58579 7.58579C3.21071 7.96086 3 8.46957 3 9L3 17H6.33333V19H15.6667V17H19V9ZM7.66667 4.33333H14.3333V7H7.66667V4.33333ZM14.3333 17.6667H7.66667V13.6667H14.3333V17.6667ZM17.6667 15.6667H15.6667V12.3333H6.33333V15.6667H4.33333V9C4.33333 8.82319 4.40357 8.65362 4.5286 8.5286C4.65362 8.40357 4.82319 8.33333 5 8.33333H17C17.1768 8.33333 17.3464 8.40357 17.4714 8.5286C17.5964 8.65362 17.6667 8.82319 17.6667 9V15.6667Z",
    fill: "#26445A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 9.66675H13V11.0001H15.6667V9.66675Z",
    fill: "#26445A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.30d5fbabe03ea36668ac09f2a335a65f.svg";
export { ForwardRef as ReactComponent };